module.exports = __webpack_public_path__ + "img/course124_summary_unit_timelines.4f2fdbb3.png";